module.exports = __webpack_public_path__ + "img/qian.9d733896.png";